import FItem from '../FItem';
import component from './component.vue';

export default class FEditor extends FItem {
  __component = component;

  constructor(props) {
    super(props);
    this.options = props.options || {};
  }
}
